import React, { useState, useEffect } from 'react';
import { Container, Spinner, Alert, Row, Col, Card, Button } from 'react-bootstrap';
import { getDatiAzienda } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faCalendarAlt, faTasks, faBox, faUsers, faFileInvoiceDollar, faWarehouse, faExchangeAlt, faCog, faChartLine, faStar } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive';
import EcommerceDashboard from './EcommerceDashboard';
import MobileDashboardHome from '../components/mobile/MobileDashboardHome';

function Home() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 991 });

  // Bottoni principali per la quick access bar
  const quickAccessModules = [
    { label: "Ordini", icon: faShoppingCart, path: "/ordini", color: "#007bff" },
    { label: "Recensioni", icon: faStar, path: "/recensioni/gestione", color: "#f39c12" },
    { label: "Film", icon: faBox, path: "/film", color: "#dc3545" },
    { label: "Musica", icon: faWarehouse, path: "/musica", color: "#17a2b8" },
    { label: "Gadget", icon: faTasks, path: "/collectibles", color: "#fd7e14" },
    { label: "Servizi", icon: faCog, path: "/servizi", color: "#6c757d" },
    { label: "Clienti", icon: faUsers, path: "/clienti", color: "#28a745" },
    { label: "Calendario", icon: faCalendarAlt, path: "/calendario", color: "#6f42c1" },
    { label: "Contabilità", icon: faFileInvoiceDollar, path: "/contabilita/dashboard", color: "#20c997" },
    { label: "IBS", icon: faExchangeAlt, path: "/integrazioni/ibs/messaggi", color: "#ffc107" },
  ];

  // Tutti i moduli per vista mobile (card grandi)
  const allModules = [
    { label: "Ordini", icon: faShoppingCart, path: "/ordini", color: "#007bff" },
    { label: "Dashboard E-commerce", icon: faChartLine, path: "/ecommerce/dashboard", color: "#17a2b8" },
    { label: "Recensioni", icon: faStar, path: "/recensioni/gestione", color: "#f39c12" },
    { label: "Integrazioni IBS", icon: faExchangeAlt, path: "/integrazioni/ibs/messaggi", color: "#ffc107" },
    { label: "Film", icon: faBox, path: "/film", color: "#dc3545" },
    { label: "Musica", icon: faWarehouse, path: "/musica", color: "#17a2b8" },
    { label: "Gadget", icon: faTasks, path: "/collectibles", color: "#fd7e14" },
    { label: "Servizi", icon: faCog, path: "/servizi", color: "#6c757d" },
    { label: "Contabilità", icon: faFileInvoiceDollar, path: "/contabilita/dashboard", color: "#20c997" },
    { label: "Calendario", icon: faCalendarAlt, path: "/calendario", color: "#6f42c1" },
    { label: "Attività", icon: faTasks, path: "/attivita", color: "#ffc107" },
    { label: "Clienti", icon: faUsers, path: "/clienti", color: "#007bff" },
    { label: "Backup", icon: faCog, path: "/impostazioni/backup-dati", color: "#6c757d" },
  ];

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      {/* Quick Access Bar (desktop) / Badge + Riepiloghi (mobile) */}
      {isMobile ? (
        <div className="px-2 pt-3">
          <MobileDashboardHome />
        </div>
      ) : (
      <div className="bg-white border-bottom shadow-sm py-3 px-4 mb-4">
        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
          {quickAccessModules.map((module, index) => (
            <Button
              key={index}
              variant="outline-secondary"
              size={isMobile ? "sm" : "sm"}
              className="d-flex align-items-center px-3 py-2"
              onClick={() => navigate(module.path)}
              style={{
                borderRadius: '20px',
                transition: 'all 0.3s ease',
                borderColor: module.color,
                color: module.color,
                fontWeight: '500',
                minWidth: 'fit-content',
                fontSize: isMobile ? '0.8rem' : '0.875rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = module.color;
                e.target.style.color = '#fff';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = module.color;
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              <FontAwesomeIcon icon={module.icon} className="me-2" size={isMobile ? "sm" : undefined} />
              {module.label}
            </Button>
          ))}
        </div>
      </div>
      )}

      {/* Dashboard E-commerce Embedded (solo desktop, su mobile c'è già MobileDashboardHome) */}
      {!isMobile && (
        <Container fluid>
          <EcommerceDashboard />
        </Container>
      )}
    </Container>
  );
}

export default Home;
